// Site-wide independence disclaimer banner.
//
// Used on: Homepage footer, Login page, About page, Contact page (per Trust
// & Safety compliance brief, iter 82). Renders as a small light card with
// an Info icon — modern SaaS feel, mobile-responsive, non-intrusive but
// always visible above the fold on its host page.
//
// Two density variants:
//   • variant="full"    — default; padded card with bold lead-in.
//   • variant="compact" — tighter padding for tight headers (Login, footer).

import { Info } from "lucide-react";

const DISCLAIMER_TEXT =
  "MDM Sahayak is an independent digital productivity and documentation assistance platform created to help simplify administrative and reporting-related tasks. It is privately operated and is not affiliated with, endorsed by, or connected to any public administration, regulatory body, school board, or programme authority.";

export default function DisclaimerBanner({ variant = "full", className = "" }) {
  const isCompact = variant === "compact";
  return (
    <aside
      role="note"
      aria-label="Independence disclaimer"
      data-testid="independence-disclaimer"
      className={`mx-auto w-full max-w-4xl rounded-2xl border border-amber-200 bg-amber-50/70 text-ink-900 shadow-[0_1px_0_rgba(0,0,0,0.02)] ${
        isCompact ? "px-4 py-2.5" : "px-5 py-4 sm:px-6 sm:py-5"
      } ${className}`}
    >
      <div className="flex items-start gap-3">
        <span
          aria-hidden="true"
          className={`mt-0.5 inline-flex shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-800 ${
            isCompact ? "h-6 w-6" : "h-8 w-8"
          }`}
        >
          <Info className={isCompact ? "h-3.5 w-3.5" : "h-4 w-4"} />
        </span>
        <p
          className={`leading-relaxed text-ink-700 ${
            isCompact ? "text-[0.72rem] sm:text-xs" : "text-xs sm:text-[0.82rem]"
          }`}
        >
          <b className="font-semibold text-ink-900">Independent Platform Notice:</b>{" "}
          {DISCLAIMER_TEXT}
        </p>
      </div>
    </aside>
  );
}

export { DISCLAIMER_TEXT };
